
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#50585B","stroke-width":"1.1","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M1 13C1 6.373 6.373 1 13 1s12 5.373 12 12c0 6.628-5.373 12-12 12S1 19.628 1 13z"}}),_c('path',{attrs:{"d":"M10.06 11.355s-.633-1.434-1.939-1.352c-1.305.082-2.15 1.55-2.12 3.124.03 1.575.833 2.802 2.199 2.871 1.366.069 2.042-1.72 2.042-1.72M12 10.067v5.883m0-2.945h2.8V10.06v5.89M19.578 10H16.9v5.95m0-2.943H19"}})])])
          )
        }
      }
    